const ACTION_TYPES = {
  ADD_PROFILE_TO_FAVOURITES: 'ADD_PROFILE_TO_FAVOURITES',
  REMOVE_PROFILE_FROM_FAVOURITES: 'REMOVE_PROFILE_FROM_FAVOURITES',
  SET_FAVOURITES: 'SET_FAVOURITES',
  SET_REMOVED_STATUS: 'SET_REMOVED_STATUS',
};

/**
 * Creates and returns favourites state actions
 * @param {func} dispatch - The dispatch function from the favourites reducer
 * @returns {Object} Actions to be used to modify favourites state
 */
const useActions = dispatch => {
  /**
   * Adds the profile to favourites state
   * @param {Object} profile - The profile to be added
   * @param {string} profile.displayName
   * @param {string} profile.id
   * @param {Array} profile.media
   * @param {Object} profile.reviewAggregates
   * @param {string} profile.stateCode
   * @param {string} profile.suburb
   * @param {string} profile.vanityUrlPath
   * @returns {void}
   */
  const addToFavourites = profile => {
    dispatch({
      type: ACTION_TYPES.ADD_PROFILE_TO_FAVOURITES,
      payload: profile,
    });
  };

  /**
   * Removes the profile from favourites state
   * @param {string} profileId - The profile ID
   * @returns {void}
   */
  const removeFromFavourites = profileId => {
    dispatch({
      type: ACTION_TYPES.REMOVE_PROFILE_FROM_FAVOURITES,
      payload: profileId,
    });
  };

  /**
   * Sets favourites to the provided array of profiles
   * @param {Array} profiles - An array of profiles
   * @returns {void}
   */
  const setFavourites = profiles => {
    dispatch({
      type: ACTION_TYPES.SET_FAVOURITES,
      payload: profiles,
    });
  };

  /**
   * Adds a removed property to the specified profile
   * Used for the saved profiles page to delay the removal of favourites, which allows the user to undo removals
   * @param {string} profileId - The profile ID
   * @returns {void}
   */
  const setRemovedStatus = profileId => {
    dispatch({
      type: ACTION_TYPES.SET_REMOVED_STATUS,
      payload: profileId,
    });
  };

  return {
    addToFavourites,
    removeFromFavourites,
    setFavourites,
    setRemovedStatus,
  };
};

export { ACTION_TYPES };
export default useActions;
